import { blue } from '@ant-design/colors';

export default {
  apiDomain: 'api.outscraper.cloud',
  homeUrl: 'outscraper.com',
  company: 'Outscraper',
  id: 'outscraper',
  theme: {
    colorPrimary: blue[5],
  },
  contactUsUrl: 'https://outscraper.com/contact-us/',
  servicesUrl: 'https://outscraper.com/services/',
  pricingUrl: 'https://outscraper.com/pricing/',
  faqUrl: 'https://outscraper.com/faq/',
  tutorialsUrl: 'https://outscraper.com/category/scraping/tutorials/',
  videosUrl: 'https://www.youtube.com/channel/UCDYOuXSEenLpt5tKNq-0l9Q',
  communityUrl: 'https://community.outscraper.com/',
  scheduleCallUrl: 'https://outscraper.com/support/#schedule',
  termsOfServiceUrl: 'https://outscraper.com/terms-of-service/',
  googleMapsCategoriesUrl: 'https://outscraper.com/google-maps-business-categories/',
  stripeApiKeys: {
    main: 'pk_live_51J0D3pCzx9P8yVtSU9tLiHuUaMzFv8J71Wtu8GXUKG2VMx6Hp63Fnpdx8ig961FRIodjzM3KwypNxhhKXAYODDvQ00BeRwsnDr',
    eu: 'pk_live_51J0D3pCzx9P8yVtSU9tLiHuUaMzFv8J71Wtu8GXUKG2VMx6Hp63Fnpdx8ig961FRIodjzM3KwypNxhhKXAYODDvQ00BeRwsnDr',
    eu2: 'pk_live_51J0D3pCzx9P8yVtSU9tLiHuUaMzFv8J71Wtu8GXUKG2VMx6Hp63Fnpdx8ig961FRIodjzM3KwypNxhhKXAYODDvQ00BeRwsnDr'
  },
  payPalClientId: 'ARueVrA72AqaNxfGjyEBsW6HlRGJXihQ_DKUPRoxpjYu4zsZ3b-2VgznwRTnlf_6gmOZVIrhjSNtNcR0',
  nmiApiKeys: {
    checkout: 'checkout_public_y7y55k3pYsH53K28G9wnV3thjM5fK96Q',
    tokenization: 'k5EYXG-KhUbFf-Mn4Mdm-d8UQwu',
  },
  availablePaymentProviders: {
    nmi: true,
    stripe: true,
    paypal: true,
    bank: true,
    crypto: true
  },
  gaToken: 'G-1Y86YSLK68',
  googleClientId: '631032570211-dj87blpft7vcnmdjc39ti9si1rdrbvu2.apps.googleusercontent.com',
  linkedinClientId: '86q0zvb58lh47x',
  hubspotClientId: '209fd49d-1607-434f-8677-b4c6fbf650eb',
  pipedriveClientId: '2653203f9ebd3230',
  zohoClientId: '1000.2A612T4JRRSUTDLJ5CYPYB3BNNQD8I',
  includedServices: [],
  headerMenuRoutes: ['/services', '/data', '/tasks'],
  learnMoreLinks: {
    emails_validator_service: '/email-list-cleaning/',
    amazon_reviews_service: '/amazon-reviews-scraper/',
    airbnb_reviews: '/airbnb-reviews-scraper/',
    airbnb_search: '/airbnb-scraper/',
    amazon_products_service: '/amazon-scraper/',
    asos_products: '/asos-scraper/',
    biggestbook_products: '/biggestbook-scraper/',
    booking_search_service: '/booking-scraper/',
    boots_products: '/boots-scraper/',
    bradyindustries_products: '/bradyindustries-scraper/',
    costco_products: '/costco-scraper/',
    customink_products: '/customink-scraper/',
    domains_service: '/emails-scraper/',
    ebay_products: '/ebay-scraper/',
    etsy_products: '/etsy-scraper/',
    expedia_search: '/expedia-scraper/',
    fastenal_products: '/fastenal-scraper/',
    glassdoor_search: '/glassdoor-scraper/',
    google_maps_photos_service: '/google-maps-photos-scraper/',
    google_maps_reviews_service: '/google-maps-reviews-scraper/',
    google_maps_traffic_service: '/google-maps-traffic-extractor/',
    google_play_reviews_service: '/google-play-reviews-scraper/',
    google_shopping_reviews_service: '/google-shopping-reviews-scraper/',
    google_trends_service: '/google-trends-scraper/',
    grainger_products: '/grainger-scraper/',
    hotels_search: '/hotels-scraper/',
    indeed_search: '/indeed-scraper/',
    iteminfo_products: '/iteminfo-scraper/',
    linkedin_companies_service: '/linkedin-companies-scraper/',
    lyreco_products: '/lyreco-scraper/',
    macys_products: '/macys-scraper/',
    officedepot_products: '/officedepot-scraper/',
    quill_products: '/quill-scraper/',
    samsclub_products: '/samsclub-scraper/',
    shopee_reviews: '/shopee-reviews-scraper/',
    shopify_products: '/shopify-scraper/',
    staples_products: '/staples-scraper/',
    tesco_products: '/tesco-products-scraper/',
    tripadvisor_reviews_service: '/tripadvisor-reviews-scraper/',
    trustpilot_reviews_service: '/trustpilot-reviews-scraper/',
    trustpilot_search_service: '/trustpilot-scraper/',
    ai_scraper_service: '/universal-ai-scraper/',
    vistaprint_products: '/vistaprint-scraper/',
    walmart_products: '/walmart-scraper/',
    waxie_products: '/waxie-scraper/',
    wbmason_products: '/wbmason-scraper/',
    webstaurantstore_products: '/webstaurantstore-scraper/',
    yellowpages_service: '/yellowpages-scraper/',
    youtube_channel_service: '/youtube-channel-scraper/',
    youtube_comments_service: '/youtube-comments-scraper/',
    youtube_search_service: '/youtube-search-scraper/',
    zillow_search_service: '/zillow-scraper/',
    hubspot_contact_finder_service: '/hubspot-enrichments/',
    hubspot_contact_emails_enricher_service: '/hubspot-enrichments/',
    phones_enricher_service: '/phone-number-lookup/',
    us_phones_enricher_service: '/phone-number-lookup/',
    google_maps_directory_service: '/google-maps-scraper/',
    google_maps_service: '/google-maps-scraper/',
    google_search_service: '/google-search-scraper/',
    google_careers_service: '/google-careers-scraper/',
    google_search_jobs_service: '/google-jobs-scraper/',
    otto_products: '/otto-scrasper/',
    newegg_products: '/newegg-scraper/',
    cdw_products: '/cdw-scraper/',
    homedepot_products: '/homedepot-scraper/',
    bestbuy_products: '/bestbuy-scraper/',
    decathlon_products: '/decathlon-scraper/',
    uline_products: '/uline-scraper/',
    menards_products: '/menards-scraper/',
    target_products: '/target-scraper/',
    napaonline_products: '/napaonline-scraper/',
    groupon_products: '/groupon-scraper/',
    gemplers_products: '/gemplers-scraper/',
    builtwith: '/builtwith-scraper/',
    better_business_bureau: '/better-business-bureau-scraper/',
    tiktok_products: '/tiktok-products',
    vrbo_search: '/vrbo-scraper/',
    shopify_apps: '/shopify-apps-scraper/',
    pinterest: '/pinterest-scraper/',
    zoro_products: '/zoro-products/',
    zalando_products: '/zalando-scraper/',
    uber_eats: '/uber-eats-scraper/',
    deliveroo: '/deliveroo-scraper/',
    deliveroo_reviews: '/deliveroo-reviews-scraper/',
    zoominfo: '/zoominfo-scraper/',
    zoominfo_domains: '/zoominfo-domains-scraper/',
    crunchbase: '/crunchbase-scraper/',
    crunchbase_search: '/crunchbase-search-scraper/',
    domaininfo: '/domaininfo-scraper/',
    olx: '/olx-scraper/',
    apollo: '/apollo-scraper/',
    feedbackcompany: '/feedbackcompany-scraper/',
    feedbackcompany_reviews: '/feedbackcompany-reviews-scraper/',
  },
  videoTutorialLinks: {
    appstore_reviews_service:'https://www.youtube.com/embed/SxGa_lXrCIU',
    domains_service: 'https://www.youtube.com/embed/_BAlDfZFVPA',
    google_maps_reviews_service: 'https://www.youtube.com/embed/1_BjMtLrrIg',
    google_maps_service: 'https://www.youtube.com/embed/mUxWvsksGJ8',
    google_search_service: 'https://www.youtube.com/embed/SxGa_lXrCIU'
  },
  tutorialsLinks:{
    ai_scraper_service: '/ai-data-scraper-tutorial/',
    domains_service: '/how-to-scrape-emails/',
    google_maps_reviews_service: '/how-to-scrape-google-maps-reviews/',
    google_maps_traffic_service: '/scrape-google-maps-traffic/',
    zillow_search_service: '/real-estate-zillow-data-extraction-no-coding-scraper/',
    google_maps_service: '/how-to-scrape-google-maps/',
    emails_validator_service: '/validate-email-addresses-bulk/',
    google_search_service: '/scraping-google-search-results'
  },
  otherLinks:{
    googleMapsIdsUrl: '/place-id-feature-id-cid/',
    googleMapsFiltersUrl: '/google-maps-data-scraper-filters/',
    googleScrapeAllPlacesUrl: '/google-maps-scrape-all-places',
    appSumoFaqUrl : '/appsumo-faq',
    enrichmentServicesUrl: '/enrichment-services/',
    enrichWithGoogleUrl: '/enrich-companies-data-with-google/?utm_source=UI',
    googleMapsDictonaryUrl: '/google-maps-scraper/#dictionary',
    findsContactsGooglePlaceUrl: '/find-contacts-google-place/',
    partnerUrl: '/targetron',
  },
  integrationsLinks: {
    zapier: 'https://zapier.com/apps/outscraper-ca1391/integrations',
    pabbly: 'https://www.pabbly.com/connect/integrations/outscraper/',
    goHighLevel: 'https://ideas.gohighlevel.com/app-marketplace/p/add-outscraper-integration',
    make: 'https://www.make.com/en/hq/app-invitation/8b5949dff444705dd9d4c77eff6341bb',
    databar: 'https://databar.ai/explore/outscraper',
    n8n: 'https://n8n.io/integrations/outscraper/'
  },
};
